declare const __SITE_URL__: string;

export const SITE_URL: string = typeof __SITE_URL__ !== "undefined" ? __SITE_URL__ : "https://sugargoospreadsheet.watch";